//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "order",
  data(){
      return {
        tabIndex:0,
        orderList:[]
      }
  },
  methods:{
      getOrderList(lx){
        this.tabIndex=lx;
        this.$vux.loading.show();
        this.orderList=[];
        var data=this.tabIndex==0?{}:{lx:this.tabIndex};
        this.axios.post('/xcx/User/orderList',data).then(res=>{
          this.orderList=res.data.data;
          this.$vux.loading.hide();
        })
      },
      pay(orderid,money){
        var _this=this;
        console.log(orderid,money);
        this.axios.post('/xcx/Order/recharge',{'order_id':orderid,'money':money}).then(res=>{
          let data=res.data.data;
          this.$wechat.chooseWXPay({
            // ...res.data.data,
            nonceStr: data.nonceStr,
            package: data.package,
            paySign: data.paySign,
            signType: data.signType,
            timestamp:Number(data.timeStamp),
            success:function (result) {
              alert('success');
              console.log(result);
              _this.getOrderList(_this.tabIndex);
            },
            cancel:function(err){
              alert('fail');
              console.log(err);
            },
            fail:function (err) {
              alert('error');
              console.log(err);
            }
          })

        })
      }
  },
  created() {
      this.getOrderList(this.tabIndex);
  }
}



// WEBPACK FOOTER //
// ./src/components/order/order.vue